var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.79.175h6.143l5.68 7.64L19.682 0l1.68.03-7.912 8.883 8.114 10.912h-6.142l-5.36-7.119L3.513 20H1.86l7.388-8.335L.79.175Zm5.564 1.128H3.11l12.982 17.365h3.187L6.354 1.303Z",
  fill: "currentColor"
})));
export default SvgX;